// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"419e87b2","496":"8d8889c6","647":"6fd79ce3"}[chunkId] + ".chunk.js";
};